import FlexBox from '@/atomic-components/FlexBox';
import { Button } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Box } from '@mui/system';
import { HelpCenterImage } from './helpcenterpdp';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import Link from 'next/link';
import LencoButton from '@/atomic-components/LencoButton';

export function HelpCenter() {
	return (
		<FlexBox
			direction='column'
			justifyContent='start'
			sx={{
				alignItem: 'start',
				position: 'relative',
				height: '430px',
				width: '560px',
				backgroundColor: '#FFFDED',
				padding: '80px 0 0 80px ',
				fontStyle: 'normal',
				border: '1px solid none',
				borderRadius: '8px',
				mb: '48px',
			}}
		>
			<LencoTypography
				sx={{
					fontSize: '20px',
					fontWeight: '500',
					fontFamily: 'Work Sans',
					color: getColor('Gray 0'),
				}}
			>
				Ask a Question
			</LencoTypography>
			<LencoTypography
				sx={{
					...getStyle('Small_Regular'),
					color: getColor('Gray -2'),
					paddingBottom: '16px',
				}}
			>
				Is this a query regarding this Product?
			</LencoTypography>

			<Link
				target={'_blank'}
				href={'https://help.furlenco.com/views/add-ticket.php'}
			>
				<LencoButton
					sx={{
						width: '200px',
						height: '40px',
						border: `1px solid ${getColor('Minty 0')}`,
						borderRadius: '20px',
						...getStyle('P_SemiBold'),
						color: getColor('Minty 0'),
						cursor: 'pointer',
						zIndex: '9',
					}}
				>
					Submit a Query
				</LencoButton>
			</Link>
			<Box
				sx={{
					position: 'absolute',
					right: '0px',
					bottom: '0px',
					paddingLeft: '24px',
				}}
			>
				<HelpCenterImage />
			</Box>

			<LencoTypography
				sx={{
					...getStyle('P_Regular'),
					color: getColor('Gray -2'),
					paddingTop: '16px',
				}}
			>
				or get Answers at the
			</LencoTypography>
			<Link target='_blank' href={'https://help.furlenco.com'}>
				<LencoTypography
					sx={{
						...getStyle('P_Medium'),
						color: getColor('Minty +1'),
						cursor: 'pointer',
						paddingTop: '16px',
						position: 'absolute',
					}}
				>
					Help Center &gt;
				</LencoTypography>
			</Link>
		</FlexBox>
	);
}
